import React, { useEffect, useState } from "react";
import close from "../../assets/svg/close.svg";
import file from "../../assets/svg/file.svg";
import drive from "../../assets/svg/drive.svg";
import truck from "../../assets/svg/truck.svg";
import time from "../../assets/svg/time.svg";
import { getDockViewApi, viewDockReferenceApi } from "./dock-api";
import DockOutModal from "./dock-out-modal";
import ReferenceSection from "./reference-section";
import { Toast, ToastContainer } from "react-bootstrap";
import ImagePreviewModal from "../common/image-preview-modal";
import PropTypes from "prop-types";

const DockTimingCard = ({ dockId, show, onClose, onSuccess }) => {
  const [showDockOutModal, setDockOutModal] = useState(false);
  const [dockView, setDockView] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [previewImage, setPreviewImage] = useState("");
  const [previewImages, setPreviewImages] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(0);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    getDockView();
  }, []);

  const getDockView = async () => {
    try {
      const response = await getDockViewApi(`${dockId}`);
      if (response.data.success === true) {
        let dockData = response.data.dock;

        try {
          const refResponse = await viewDockReferenceApi(dockId);
          if (refResponse?.data?.success && refResponse.data.data) {
            // Check if it's an array for some reason or just empty object
            if (Array.isArray(refResponse.data.data)) {
              dockData.references = refResponse.data.data;
            } else if (Object.keys(refResponse.data.data).length === 0) {
              dockData.references = [];
            } else {
              dockData.references = [refResponse.data.data];
            }
          } else {
            dockData.references = [];
          }
        } catch (e) {
          dockData.references = [];
        }

        setDockView(dockData);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  if (!show) return null;

  const onSuccessDockOut = async (response) => {
    setDockOutModal(false);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    getDockView();
    if (onSuccess) {
      onSuccess(response);
    }
  };
  return (
    <div
      className="container-fluid"
      style={{
        fontFamily: "Epilogue",
        maxWidth: "100%",
        height: "100%",
        overflowY: "auto",
        padding: "20px",
        background: "#fff",
      }}
    >
      {showDockOutModal && (
        <DockOutModal
          dockId={dockView.id}
          onProceed={onSuccessDockOut}
          onCancel={() => {
            setDockOutModal(false);
          }}
        />
      )}
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center" style={{ background: "#f5f5f5", margin: "-20px", padding: "24px" }}>
        <div>
          <h2
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "24px",
              fontWeight: "800",
            }}
          >
            {dockView.vehicle_number || "N/A"}
          </h2>
          <p style={{ fontSize: "12px", color: "gray", margin: 0 }}>Created on {dockView.created_date || "-"}</p>
        </div>
        <div className="d-flex align-items-center justify-content-end gap-2" style={{ position: "relative", padding: "10px" }}>
          {dockView.in_time != null && dockView.in_time !== "" && dockView.out_time === null && (
            <div className="style-justify-center">
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  cursor: "pointer",
                  background: "#D35258",
                  borderRadius: "100px",
                  width: "112px",
                  height: "33px",
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#FFFFFF",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setDockOutModal(true);
                  /*  setVisitorDetails(visitor);
                                    setSelectedStatus("Reject"); */
                }}
              >
                Dock Out
              </div>
            </div>
          )}
          {[close].map((icon, idx) => (
            <button
              key={idx}
              onClick={onClose}
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                background: "#ffff",
                border: "none",
                cursor: "pointer",
                padding: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src={icon} alt="icon" style={{ width: "16px", height: "16px" }} />
            </button>
          ))}
        </div>
      </div>

      {/* Info Section */}
      <div style={{ marginTop: "36px", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <img src={truck} alt="Container" style={{ width: "20px", height: "20px", marginRight: "8px" }} />
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Vehicle Number
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.vehiclestype || "N/A"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <img src={drive} alt="User" style={{ width: "20px", height: "20px", marginRight: "8px" }} />
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Driver Name
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.driver_name || "N/A"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} />
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Dock Number
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.display_name || "N/A"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            {/* <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} /> */}
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Department
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.department || "N/A"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            {/*  <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} /> */}
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Dock Type
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.dock_type === "load_in" ? "Loading" : ""} {dockView.dock_type === "load_out" ? "Unloading" : ""}
          </p>
        </div>
        {dockView.dock_type === "load_in" && (
          <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
            <div
              style={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              {/* <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} /> */}
              <span
                style={{
                  color: "#D35258",
                  fontFamily: "Epilogue",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Vendor
              </span>
            </div>
            <p
              style={{
                margin: 0,
                fontFamily: "Epilogue",
                fontSize: "14px",
                fontWeight: "400",
                color: "#172B4D",
              }}
            >
              {dockView.vendor || "N/A"}
            </p>
          </div>
        )}
        {dockView.dock_type === "load_out" && (
          <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
            <div
              style={{
                width: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              {/* <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} /> */}
              <span
                style={{
                  color: "#D35258",
                  fontFamily: "Epilogue",
                  fontWeight: "500",
                  fontSize: "14px",
                }}
              >
                Customer
              </span>
            </div>
            <p
              style={{
                margin: 0,
                fontFamily: "Epilogue",
                fontSize: "14px",
                fontWeight: "400",
                color: "#172B4D",
              }}
            >
              {dockView.customer || "N/A"}
            </p>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", margin: "10px 0" }}>
          <div
            style={{
              width: "200px",
              display: "flex",
              alignItems: "center",
              justifyContent: "start",
            }}
          >
            {/* <img src={file} alt="Location" style={{ width: "20px", height: "20px", marginRight: "8px" }} /> */}
            <span
              style={{
                color: "#D35258",
                fontFamily: "Epilogue",
                fontWeight: "500",
                fontSize: "14px",
              }}
            >
              Product Type
            </span>
          </div>
          <p
            style={{
              margin: 0,
              fontFamily: "Epilogue",
              fontSize: "14px",
              fontWeight: "400",
              color: "#172B4D",
            }}
          >
            {dockView.product_type || "N/A"}
          </p>
        </div>
      </div>

      {/* Timing Section */}
      <div className="mt-3">
        <h3
          style={{
            fontSize: "16px",
            fontWeight: "700",
            fontFamily: "Epilogue",
            color: "#172B4D",
          }}
        >
          Timing details
        </h3>

        <div className="d-flex align-items-center justify-content-between flex-wrap mt-2 position-relative">
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "0",
              right: "0",
              borderTop: "1px dashed #FFA1A5",
              zIndex: 0,
            }}
          ></div>

          {[
            ["Dock in time", dockView.in_time || "N/A"],
            ["center", dockView.duration || "N/A"],
            ["Dock out time", dockView.out_time || "N/A"],
          ].map((item, i) =>
            i === 1 ? (
              <div
                key={i}
                className="mx-2 d-flex align-items-center"
                style={{
                  fontSize: "14px",
                  borderRadius: "35px",
                  background: "#FFEBEC",
                  padding: "8px 12px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                  position: "relative",
                  zIndex: 3,
                  color: "#172B4D",
                  fontFamily: "Epilogue",
                  gap: "6px",
                }}
              >
                <img src={time} alt="clock" style={{ width: "16px", height: "16px" }} />
                {item[1]}
              </div>
            ) : (
              <div
                key={i}
                className="flex-grow-1 mx-1"
                style={{
                  border: "1px dashed #FFA1A5",
                  borderRadius: "8px",
                  padding: "10px",
                  fontSize: "12px",
                  maxWidth: "200px",
                  textAlign: "left",
                  position: "relative",
                  zIndex: 2,
                  background: "#fff",
                }}
              >
                <div
                  style={{
                    color: "#D35258",
                    fontFamily: "Epilogue",
                    fontWeight: "500",
                    fontSize: "12px",
                  }}
                >
                  {item[0]}
                </div>
                <div
                  style={{
                    color: "#2F3941",
                    fontFamily: "Epilogue",
                    fontWeight: "600",
                    fontSize: "13px",
                  }}
                >
                  {item[1]}
                </div>

                <div
                  style={{
                    color: "#21272c",
                    fontSize: "12px",
                    marginTop: "2px",
                    fontWeight: "400",
                  }}
                >
                  {i === 0 ? `by ${dockView.dock_in_user || "N/A"}` : `by ${dockView.dock_out_user || "N/A"}`}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
      {dockView.in_delay_reason && (
        <div className="mt-3">
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              fontFamily: "Epilogue",
              color: "#172B4D",
            }}
          >
            Dock In Delay Reason
          </h3>
          <p style={{ fontSize: "12px", color: "gray", margin: 0 }}>{dockView.in_delay_reason || "-"}</p>
        </div>
      )}
      {dockView.in_attachments?.length > 0 && (
        <div className="mt-3">
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "700",
              fontFamily: "Epilogue",
              color: "#172B4D",
            }}
          >
            Dock In Attachment
          </h3>
          <div style={{ display: "flex", gap: "12px", overflowX: "auto", padding: "4px" }} className="hide-scroll">
            {dockView.in_attachments?.map((baseImage, index) => (
              <div key={"gate-in-image-" + index} style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={baseImage != null && baseImage !== "" ? baseImage : ""}
                  alt="complaint"
                  style={{ width: "72px", height: "72px", borderRadius: "14px", border: "1px solid #E5E5E5", cursor: "pointer" }}
                  onClick={() => {
                    setPreviewImages(dockView.in_attachments);
                    setPreviewIndex(index);
                    setShowPreview(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {dockView.out_delay_reason && (
        <div className="mt-3">
          <h3
            style={{
              fontSize: "14px",
              fontWeight: "700",
              fontFamily: "Epilogue",
              color: "#172B4D",
            }}
          >
            Dock Out Delay Reason
          </h3>
          <p style={{ fontSize: "12px", color: "gray", margin: 0 }}>{dockView.out_delay_reason || "-"}</p>
        </div>
      )}
      {dockView.out_attachments?.length > 0 && (
        <div className="mt-3">
          <h3
            style={{
              fontSize: "16px",
              fontWeight: "700",
              fontFamily: "Epilogue",
              color: "#172B4D",
            }}
          >
            Dock Out Attachment
          </h3>
          <div style={{ display: "flex", gap: "12px", overflowX: "auto", padding: "4px" }} className="hide-scroll">
            {dockView.out_attachments?.map((baseImage, index) => (
              <div key={"gate-out-image-" + index} style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={baseImage != null && baseImage !== "" ? baseImage : ""}
                  alt="complaint"
                  style={{ width: "72px", height: "72px", borderRadius: "14px", border: "1px solid #E5E5E5", cursor: "pointer" }}
                  onClick={() => {
                    setPreviewImages(dockView.out_attachments);
                    setPreviewIndex(index);
                    setShowPreview(true);
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
      <ReferenceSection
        dockId={dockView.id}
        dockMasterId={dockView.dock_id}
        departmentId={dockView.department_id}
        activityType={dockView.dock_type === "load_in" ? "loading" : "unloading"}
        references={dockView.references || []}
        canEdit={dockView.in_time != null && dockView.in_time !== "" && (dockView.out_time === null || dockView.out_time === "")}
        onUpdate={(updatedRefs) => {
          setDockView((prev) => ({ ...prev, references: updatedRefs }));
        }}
        onRefresh={getDockView}
      />
      {/* Summary Section */}
      {/* <div className="mt-3">
        <h3 style={{ fontSize: "14px", fontWeight: "bold" }}>Summary</h3>
        <div className="d-flex flex-column" style={{ gap: "20px", marginTop: "16px", paddingLeft: "40px", position: "relative" }}>
          {[
            { img: inc, label: "Dock In", time: "May 23, 2024 at 04:30 PM" },
            { img: ls, label: "Loading Started", time: "May 23, 2024 at 04:40 PM" },
            { img: lc, label: "Loading Completed", time: "May 23, 2024 at 05:10 PM" },
            { img: out, label: "Dock Out", time: "May 23, 2024 at 05:30 PM" },
          ].map((item, index, arr) => (
            <div key={index} style={{ position: "relative", height: "60px" }}>
              {index !== arr.length - 1 && <div style={{ position: "absolute", top: "10px", bottom: "-18px", left: "-16px", width: "0", borderLeft: "2px dashed #bbb", zIndex: 0 }}></div>}

              <div className="d-flex align-items-start" style={{ gap: "12px", position: "relative", zIndex: 1 }}>
                <div style={{ width: "24px", height: "24px", borderRadius: "50%", padding: "12px", backgroundColor: "#F5F6F7", display: "flex", alignItems: "center", justifyContent: "center", position: "absolute", left: "-28px", top: "0", zIndex: 2 }}>
                  <img src={item.img} alt={item.label} style={{ width: "16px", height: "16px" }} />
                </div>

                <div style={{ fontSize: "14px", lineHeight: "1.5", marginLeft: "20px", color: "#172B4D", fontFamily: "Epilogue", fontWeight: "700" }}>
                  <strong>{item.label}</strong>
                  <div style={{ fontSize: "12px", lineHeight: "1.5", color: "#8790A1", fontFamily: "Epilogue", fontWeight: "400" }}>{item.time}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <ImagePreviewModal 
        show={showPreview} 
        images={previewImages} 
        initialIndex={previewIndex} 
        onHide={() => setShowPreview(false)} 
      />
    </div>
  );
};

DockTimingCard.propTypes = {
  dockId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

export default DockTimingCard;
